// Removing a toolkit (02-DESIGN/08-toolkits/02-the-mcp-runtime.md § the
// settings document; 01-the-console.md § conventions: remove): its workload
// retired, then its settings document deleted. The one act behind *Remove*
// on the toolkit's page and in its row menu on the Toolkits table.

import type { Bus } from "../../platform/bus.ts";
import { describe } from "../../ui/components.tsx";
import type { MenuEntry } from "../../ui/table.tsx";
import { DOCUMENT } from "../../wire/toolkit-mcp.ts";
import { idSubject, SERVICE as WORKLOADS, type StateReply } from "../../wire/workloads.ts";

/** removeConsequence is what removing a toolkit does, in the person's words. */
export function removeConsequence(name: string): string {
  return `For good: ${name} stops, its settings are gone, and nothing can call its tools. What people linked stays stored until they unlink.`;
}

/**
 * removeToolkit retires the toolkit's workload and deletes its settings. A
 * toolkit that stopped but whose settings stayed is said as such: they stay
 * under Configuration.
 */
export async function removeToolkit(bus: Bus, workload: string): Promise<void> {
  await bus.call<StateReply>(WORKLOADS, idSubject("retire", workload), undefined, 30000);
  try {
    await bus.config().delete(workload, DOCUMENT);
  } catch (e) {
    throw new Error(
      `The toolkit stopped, but its settings could not be removed: ${describe(e)}. They stay under Configuration.`,
      { cause: e },
    );
  }
}

/** removeMenu is an admin's last entry of a toolkit's row menu: *Remove the toolkit*, asked first. */
export function removeMenu(name: string, remove: () => void): MenuEntry[] {
  return [
    {
      label: "Remove the toolkit",
      danger: true,
      confirm: { title: `Remove toolkit ${name}?`, consequence: removeConsequence(name), verb: "Remove" },
      onSelect: remove,
    },
  ];
}
